<div class="dialog-container" [ngClass]="{ 'modal-body': !fromInvite, 'w-[392px] rounded-xl ': isFromNetworkRequest }">
  <div class="web-close-icon" [class.hidden]="fromInvite || isFromNetworkRequest">
    <button
      style="top: -12px !important; right: -12px !important"
      matTooltipPosition="above"
      matTooltipClass="custom-tooltip-margin-bottom"
      data-dismiss="modal"
      (click)="activeModal.dismiss('cancel')"
      class="web-close-btn"
    >
      <span class="material-icons" style="position: relative; font-size: 1.8rem !important">clear</span>
    </button>
  </div>

  <div class="mobile-header-divider" [ngClass]="hideText ? 'hidetext-container-main' : ''"></div>

  @if (!fromInvite) {
  <div class="media flex" style="align-items: baseline" [ngClass]="{ 'justify-between': isFromNetworkRequest }">
    <div class="avatat-container">
      @if (!isInvite) {
      <div class="media-left">
        <ngx-avatars
          size="40"
          src="{{ data?.user?.user_profile_image_url }}"
          name="{{ data?.user?.user_first_middle_name + ' ' + data?.user?.user_last_name | titlecase }}"
          [round]="true"
          initialsSize="2"
        ></ngx-avatars>
      </div>
      } @if (data.user && isInvite) {
      <div class="media-body">
        <h4>Invite {{ data.user.user_first_middle_name + ' ' + data.user.user_last_name | titlecase | truncateStrPipe : 25 }}</h4>
      </div>
      } @if (data.user && !isInvite) {
      <div class="media-body">
        <h4 class="media-heading">{{ data?.user?.user_first_middle_name + ' ' + data?.user?.user_last_name | titlecase | truncateStrPipe : 25 }}</h4>
        <!-- <span class="relationship-name">{{ data?.user?.relationship_name }}</span>
            <p>
              <ng-container *ngIf="data.user.location_city">
                {{ data?.user?.location_city + ',' }}
              </ng-container>
              <ng-container *ngIf="data.user.state_name">
                {{ data?.user?.state_name }}
              </ng-container>
              <br />
              <ng-container *ngIf="data.user.work_postition">
                {{ data?.user?.work_postition + ',' }}
              </ng-container>
              <ng-container *ngIf="data.user.work_company">
                {{ data?.user?.work_company }}
              </ng-container>
            </p> -->
      </div>
      } @if (!data.user) {
      <div class="media-body">
        <h4 class="media-heading" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 300px">
          {{ data?.user_first_middle_name }} {{ data?.user_last_name }}
        </h4>
      </div>
      }
    </div>
    <!-- <div class="webCloseIcon">
      <div (click)="activeModal.dismiss('cancel')" class="media-right">
        <i class="fa fa-times-circle"></i>
      </div>
    </div> -->
    @if(isFromNetworkRequest){
    <button
      matTooltipPosition="above"
      matTooltipClass="custom-tooltip-margin-bottom"
      data-dismiss="modal"
      (click)="activeModal.dismiss('cancel')"
      class="web-close-btn bg-transparent p-0"
    >
      <span class="material-icons" style="position: relative">clear</span>
    </button>
    }
    <div class="mobileCloseIcon">
      <div (click)="activeModal.dismiss('cancel')" class="media-right add-close-button">
        <i class="material-icons icons-close-mobile">close</i>
      </div>
    </div>
  </div>
  }
  <!-- Material UI -->
  <form [formGroup]="connectionRelationshipForm" class="connect-relationship-form">
    <!-- 1st tier relationship -->
    <div [class]="isConnectionSearch ? 'relative top-[7px]' : ''">
      <mat-form-field
        #formField
        [floatLabel]="editName ? 'always' : ''"
        appearance="fill"
        disableControl="condition"
        style="width: 100% !important"
        [ngClass]="
          hideText && !isGuardian && !isConnectionModalBtn
            ? 'automtic-form-desing-edit-relationship-white-background'
            : hideText && isGuardian && !isConnectionModalBtn
            ? 'change-password-form-desing dessing-password'
            : !hideText && isGuardian && !isConnectionModalBtn
            ? 'change-password-form-desing dessing-password'
            : isConnectionModalBtn
            ? 'connection_form automtic-form-desing-form-only add-automtic-form-desing'
            : 'automtic-form-desing-edit-relationship '
        "
        [class]="isConnectionModalBtn ? '' : 'change-password-form-desing dessing-password'"
        class="app__medium--height--form relationship-type-form"
      >
        <mat-label class="automtic-form-desing-lable">
          How are they related to
          <span> {{ truncatedName }}?</span>
        </mat-label>

        @if (!editName) {
        <input
          type="text"
          [placeholder]="placeHolder"
          aria-label="Number"
          matInput
          formControlName="relationshipType"
          [matAutocomplete]="auto"
          [disabled]="this.setDefaultRelationship"
          (keydown)="handleTabFix($event)"
          [matTooltip]="isConnectionSearch ? placeHolder : ''"
        />}@else{
        <input
          (ngModelChange)="setEditName($event)"
          [placeholder]="placeHolder"
          type="text"
          [(value)]="editName"
          [(ngModel)]="editName"
          matInput
          [matAutocomplete]="auto"
          (keydown)="handleTabFix($event)"
          [matTooltip]="isConnectionSearch ? placeHolder : ''"
        />
        } @if(isFromNetworkRequest){
        <span class="material-icons e8e5 graph-icon absolute right-0 top-4 text-k-blue rotate-90">chevron_right </span>
        }
        <mat-autocomplete [class]="getClass(dropdownClass)" autoActiveFirstOption #auto="matAutocomplete">
          @for (option of filteredOptions | async; track option) {
          <mat-option class="mobile-mat-option" style="color: #707070" [value]="option.name">
            {{ option.name }}
          </mat-option>
          } @if (noResults) {
          <mat-option (click)="navigateToHelp($event, helpCenterLink)" class="cursor-pointer relative">
            <a target="_blank" href="{{ helpCenterLink }}" class="nor-result absolute z-50 top-0">
              Can’t find what you’re looking for? Let us help.
            </a>
          </mat-option>
          }
        </mat-autocomplete>
        @if(!isFromNetworkRequest){
        <div class="absolute right-[-4px] top-4 bg-white">
          @if (connectionRelationshipForm.controls['relationshipType']?.value?.length) {
          <button class="hover:bg-transparent bg-transparent text-k-black" matSuffix aria-label="Clear" (click)="clearData()">
            <mat-icon>close</mat-icon>
          </button>
          } @if (!connectionRelationshipForm.controls['relationshipType']?.value?.length) {
          <button class="hover:bg-transparent bg-transparent text-k-blue relative right-[-4px]" aria-label="Clear" matSuffix (click)="clearData()">
            <mat-icon class="text-k-blue">keyboard_arrow_down</mat-icon>
          </button>
          }
        </div>
        }
      </mat-form-field>
    </div>

    @if (!fromInvite) {
    <div class="action text-center btn-container">
      @if (isEdit) {
      <button
        type="submit"
        class="app__btn--primary m-0"
        [class.disable-button-continue]="
          makeAddButtonDisable ||
          !connectionRelationshipForm.controls.FullName.valid ||
          !connectionRelationshipForm.controls.requested_user_id.valid ||
          !RelationshipFormNgForm.valid
        "
        (click)="doRelationshipUpdate(data?.user)"
      >
        Save
      </button>
      } @if (!isEdit) {
      <button
        style="width: 100% !important; height: 36px !important"
        mat-raised-button
        type="submit"
        class="add-button bg-k-blue text-white"
        id="connect_btn"
        [class.disable-button-continue]="
          makeAddButtonDisable ||
          !connectionRelationshipForm.controls.FullName.valid ||
          !connectionRelationshipForm.controls.requested_user_id.valid ||
          !RelationshipFormNgForm.valid
        "
        (click)="doRelationshipConnect(data)"
      >
        Connect
      </button>
      <!-- [class.disable-button-continue]="
                makeAddButtonDisable ||
                !connectionRelationshipForm.controls.FullName.valid ||
                !connectionRelationshipForm.controls.requested_user_id.valid || 
                !RelationshipFormNgForm.valid 
                " -->
      }
    </div>
    }
  </form>
</div>
